import PasswordReset from '../../PasswordReset/PasswordReset';

const PasswordResetScreen = () => <PasswordReset />;

export default PasswordResetScreen;
